import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CommonService} from '../services/common.service';
import { constants } from 'src/app/shared/common/contants';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-filedownload',
    template: `
      <a (click)="openInVault($event)" style="color: cornflowerblue;">{{fileName}}</a>`,
    standalone: false
})

export class VaultReference implements ICellRendererAngularComp {

    fileName:any= "Open in Vault";
    params:any;
    sessionid:any;
    documentId:any;

agInit(params): void {
    this.params= params; 
    if(params.data.vaultuploadstatus!=="Sent to Vault"){
        this.fileName="";
    }
}

constructor( 
    private commonService: CommonService,
    private snackbar: MatSnackBar,
    ) { }
refresh(params: ICellRendererParams<any, any>): boolean {
    return true;
}


openInVault($event){
console.log(this.params.data)
var documentId = this.params.data.documentId
let loggedDns = localStorage.getItem("vaultDnsname")
// console.log("documentid= "+ documentId)
// console.log("Logged In dns" + loggedDns)
/**
 * @modifiedBy Ashwin M
 * 08/02/2024
 * code modified to retrieve target valult dns name to view reports uploaded into vault
 */
this.commonService.retrieveVaultDnsname(loggedDns).subscribe((res)=>{
    if(res.error == true){
        this.snackbar.open("Target Vault DNS not configured for "+ loggedDns + " DNS", "OK", {duration: 5000})
    }else{
 let vaultDocUrl ="https://" + res.data + "/ui/#doc_info/+"+documentId;
    window.open(vaultDocUrl, '_blank');
    }

});
}
}
